const initialState = {
  payload: null,
  loading: null,
  logSocket: [],
};

export default initialState;
